<template>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" :class="className">
    <path d="M5 12h14" />
  </svg>
</template>

<script>
export default {
  name: 'IconMinus',
  props: { className: { type: String, default: 'w-4 h-4' } },
}
</script>

